import { render } from "./RealtimeAuthNotice.vue?vue&type=template&id=4709ad61&scoped=true"
import script from "./RealtimeAuthNotice.vue?vue&type=script&lang=js"
export * from "./RealtimeAuthNotice.vue?vue&type=script&lang=js"

import "./RealtimeAuthNotice.vue?vue&type=style&index=0&id=4709ad61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4709ad61"]])

export default __exports__